import type { GlobalState } from 'little-state-machine'

export const updateShowMinicart = (
  state: GlobalState,
  payload: {
    showMinicart: boolean
  },
) => ({
  ...state,
  showMinicart: payload.showMinicart,
})

export const setIsCartBusy = (state: GlobalState, isCartBusy: boolean) => ({
  ...state,
  isCartBusy,
})
